/**
 * PLugin helpers
 */
export default {
  /**
   * Send an AJAX request and return response data in JSON format
   *
   * @param {string} url Request URL
   * @param {object} data Request data
   *
   * @return {Promise}
   */
  sendRequest(url, data) {
    return new Promise((resolve, reject) => {
      // send request
      fetch(url, data)
        // force JSON response
        .then((response) => response.json())
        // response processing
        .then((json) => {
          // resquest failed
          if (!json || !json.success) {
            reject(json);
            return;
          }

          resolve(json.data);

          return json.data;
        })
        .catch((err) => {
          console.error('Licorn Alert Subscriber - Request', err);
          reject(err);
        });
    });
  },
};
